var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9996 15.4817V17.5893C19.0004 17.7849 18.9602 17.9786 18.8817 18.1578C18.8031 18.3371 18.6879 18.498 18.5435 18.6303C18.399 18.7626 18.2285 18.8633 18.0428 18.9259C17.8571 18.9886 17.6603 19.0119 17.465 18.9943C15.299 18.7594 13.2183 18.0207 11.3902 16.8376C9.68945 15.7589 8.24748 14.3198 7.16674 12.6224C5.9771 10.7897 5.23677 8.70306 5.00571 6.53156C4.98812 6.33729 5.01126 6.1415 5.07364 5.95664C5.13603 5.77178 5.2363 5.60191 5.36807 5.45785C5.49984 5.31378 5.66022 5.19868 5.839 5.11986C6.01779 5.04105 6.21106 5.00025 6.40651 5.00007H8.51826C8.85987 4.99671 9.19105 5.11744 9.45007 5.33976C9.70909 5.56208 9.87828 5.87081 9.92609 6.20841C10.0152 6.88287 10.1805 7.54511 10.4188 8.18249C10.5135 8.43394 10.534 8.70721 10.4779 8.96993C10.4218 9.23265 10.2913 9.4738 10.1021 9.66481L9.20809 10.557C10.2102 12.3158 11.6693 13.7721 13.4316 14.7721L14.3256 13.8799C14.517 13.6911 14.7586 13.5609 15.0218 13.5049C15.2851 13.4488 15.5589 13.4693 15.8108 13.5638C16.4495 13.8016 17.113 13.9666 17.7888 14.0556C18.1308 14.1037 18.4431 14.2756 18.6663 14.5386C18.8895 14.8015 19.0081 15.1372 18.9996 15.4817Z",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.d8afbe01c23f51d93d15b5a4783d3313.svg";
export { ForwardRef as ReactComponent };